/**
 * 作业明细报表配置(页面完全一样，页面复用 - work-detail)
 * Outter Key(如schedule-order、schedule-bike...)对应页面类型，用于区分页面，与路由配置保持一致
 * @var {String} cid 页面埋点id
 * @var {String} pageId 页面id，请求必要参数
 * @var {String} exportFileName 导出表名称
 * @var {String} filterPartnerStaffLabel 姓名筛选label
 * @var {String} showHeaderTip table是否显示头部指标注释
 * @var {String} isShowSupplierFilter 是否显示合作商筛选项
 */
export const WORK_DETAIL = {
  'schedule-order': {
    cid: 'c_mobikeops_ursv1yqw',
    pageId: 'schedule_work_order_detail',
    exportFileName: '调度作业明细-工单维度',
    filterPartnerStaffLabel: '调度用户姓名',
  },
  'schedule-bike': {
    cid: 'c_mobikeops_z4qe0yu1',
    pageId: 'schedule_bike_detail',
    exportFileName: '调度作业明细-车辆维度',
    filterPartnerStaffLabel: '调度司机姓名',
  },
  'schedule-retrieve': {
    cid: 'c_mobikeops_rgxzi6vp',
    pageId: 'schedule_retrieve_page',
    exportFileName: '寻回作业明细',
    filterPartnerStaffLabel: '寻回人员姓名',
  },
  'change-power': {
    cid: 'c_mobikeops_ybjlu3gv',
    pageId: 'change_power_detail',
    exportFileName: '换电作业明细',
    filterPartnerStaffLabel: '换电人姓名',
    showHeaderTip: true,
    isShowSupplierFilter: true,
  },
}
